import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Avatar,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Getrequest, Postrequest, Putrequest } from "../../../../../../context/AxiosRequest";
import { ContextData } from "../../../../../../context/Context";
import _ from "lodash";
import { all } from "axios";
import SendRejectDocumentMssg from "../../../ApplicantProfile/SendRejectDocumentMssg";
import { toast } from "react-toastify";
import SoundAlert from "../../../../../../routes/SoundAlert";
import baseUrl from "../../../../../../BaseURL";
import { useNavigate } from "react-router-dom";
import CalculatorDialogue from "./CalculatorDialogue";
import GetAdminCredentials from "../../../../../../context/GetAdminCredentials";




 const FilterList = {
      
  bio_data: ["fname","md_name","lname","mobileNumber","gender","marital_status","d_o_b","resdential_type"],
  demography_data: ["state_of_origin","local_gov","home_address","city_town"],
  parent_data: ["father_full_name","mother_full_name","guardian_valid_mobile"],
  edu_data: ["matric_num","university","faculty","deparment","current_level","gpa","applying_for_type","year_of_admission","year_of_graduation","course_of_study","nelfund_status","nelfund_indicator"],
  bank_details_data: ["bank_name","account_name","account_number","nin_number","bvn_number","tin_number"],
  social_media_data: ["facebook_handle","twitter_handle","instergram_handle","linkedin_handle"],
  loanrequest: ["loan_amount","tenor","net_monthly_income","program_type","loan_category"],
  sponsorIdentification: ["first_name","middle_name","surname","date_of_birth","gender","marital_status","phone_no_1","phone_no_2","email","number_of_dependants","mother_maiden_name","bvn","nin_number","tin_number","billing_address"],
  spouse_details: ["first_name","middle_name","surname","office_address","phone_no_1","phone_no_2","email"],
  residentialAddress: ["residential_address","residential_status","years_in_apartment","nearest_landmark","profession","profession_type","position"],
  employment_details: ["employer_name","employer_address","year_of_confirmation","gross_annual_income","psn_ippis","year_of_retirement","net_monthly_income","grade_level","salary_payment_date","employee_id","qualification"],
  salary_bank_details: ["account_name","bank","account_number","account_type","signature_date"],
  personal_references: ["first_ref_first_name","first_ref_middle_name","first_ref_surname","first_ref_relationship","first_ref_address","first_ref_phone_no_1","first_ref_phone_no_2","first_ref_email","second_ref_first_name","second_ref_middle_name","second_ref_surname","second_ref_relationship","second_ref_address","second_ref_phone_no_1","second_ref_phone_no_2","second_ref_email"],
  guarantor_details: ["first_name","middle_name","surname","date_of_birth","gender","phone_no_1","phone_no_2","marital_status","email","psn_no","mother_maiden_name","account_name","account_number","bvn","nin_number","bank_name","tin_number","home_address","office_address"],
 
 }

function niceLabel(key) {
  if (!key) return "";
  return key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase())
    .replace(/\bPsn\b/gi, "PSN")
    .replace(/\bNin\b/gi, "NIN")
    .replace(/\bBvn\b/gi, "BVN")
    .replace(/\bFname\b/gi, "First Name")
    .replace(/\bLname\b/gi, "Last Name")
    .replace(/\bd o b\b/gi, "Date Of Birth")
}


function MainCard({ allData,filterData,type,usesomeDate,loan_category,from,verifierToken,file_token,applicanttoken,id}) {

    
      const {UserTokens,accesstoken} = useContext(ContextData)
      const [acknowledged,setAcknowledged] = useState([])
     
      const [load,setload] = useState(true)
      const [Allinputs,setAllinputs]  = useState()
      const data = {
           mssg:"acknowledged",
           user_token:applicanttoken,
           loan_category: loan_category?.loan_category
      }
      const Navigate =  useNavigate()
       
 const acknowledge = () => {


            
     (async () => {


              
               const response2 = await Getrequest(`/auth/check_if_all_inputs_fill/${applicanttoken}`,accesstoken)
                setAllinputs(response2)
       
          
                           
                 //  const checkLoanRequst = Allinputs  && Allinputs.every(inputs => inputs === "" || inputs === null)
                  const checks = Object.keys(response2 || {}).map(k => response2[k]);
                  const facts = checks.every(input => input !== "" && input !== null && input !== undefined);
                    

                 if(!facts){

                        toast.warn("All inputs are required before acknowledgment")
                        SoundAlert("error")
                        return

                 }else{
                      

                 if(loan_category?.loan_category){

                 const responseDoc = await Getrequest(`/auth/check_If_all_files_are_provided/${applicanttoken}/${loan_category?.loan_category}`,accesstoken)

                      if(!responseDoc.status){

                            toast.warn(responseDoc.textStatus)
                            SoundAlert("error")

                      }else if(responseDoc.status){
  


             const response = await Putrequest(`/auth/acknowledgment`,data,accesstoken)

          if(response.status){


            setload(!load)
            toast.success(response.textStatus)
           
            SoundAlert("success")
            setAcknowledged([])


          

          }else{

            toast.error(response.textStatus)
            SoundAlert("error")


          } 






                      }


               }else{

                   toast.warn("Error while connecting...")
                   SoundAlert("error")
               }
          
        

   
        } 
                    
         
     
          

     })()



  }


  useEffect(()=>{

             (async () => {

         
          const response = await Getrequest(`/auth/acknowledgment/${applicanttoken}`,accesstoken)
          
                           
              setAcknowledged(response) 
 
     })()



  },[load])





  return (
   <Card id={id} className="rounded-xl shadow-md overflow-hidden font-mono">

                  <Box className="p-4 bg-gradient-to-r from-sky-100 to-white border-b">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-md bg-white/60 flex items-center justify-center shadow-sm">
                          <InfoOutlinedIcon fontSize="small" className="text-sky-600" />
                        </div>
                        <div>
                          <Typography variant="subtitle1" className="font-semibold ">
                             <span className="preview-field-count-text-head">

                             {["bio_data","demography_data","ACADEMIC DETAILS","BANK DETAILS","Social Media Details"].includes(type) && "STUDENT"} {niceLabel(type).toUpperCase()}

                             </span>
                          </Typography>

                           {
                               type ===  "bio_data" &&
                          <div className="flex justify-center items-center flex-col gap-4">
                              

                            
                          
                          <p>{Object.keys(filterData || {}).length} field(s)</p>
                          
                             {
                              from === "viewdoc" &&

                               <div>
                                 <SendRejectDocumentMssg from={from} applicanttoken={applicanttoken} UserTokens={allData?.user_tokens} verifierToken={verifierToken} file_token={file_token} />
                               </div>
                             }
                           
                            </div>
                           }
                            


                        </div>
                      </div>
                      <div className="text-sm text-gray-500"> 

                              {
                              type !==  "bio_data" &&
                            <div className="flex justify-center items-center gap-4">

                                  {
                                     from === "viewdoc" &&
                               <div>
                                 <SendRejectDocumentMssg from={from} applicanttoken={applicanttoken} UserTokens={allData?.user_tokens} verifierToken={verifierToken} file_token={file_token} />
                               </div>
                                  }

                          
                           
                          <p className="preview-field-count-text">{Object.keys(filterData || {}).length} field(s)</p>
                         
                            </div>
                          }
                            
                          {
                            type ===  "bio_data" &&
                          <div className="w-[40%] flex justify-center items-center show_main-header-preview-page-con_image_dp">
                           
                             <Avatar variant="rounded" sx={{ width: 150, height: 150 }} src={`${baseUrl}/get_photo/${allData.picture}`} className="shadow-lg">KS</Avatar> 
                                     
                              </div>
                          }
                      </div>
                    </div>
                  </Box>

                  <CardContent className="p-6 bg-white">
                     {
                            type ===  "bio_data" &&
                          <div className="w-[100%] flex justify-center items-center show_main-header-preview-page-con_image_mb">
                           
                             <Avatar variant="rounded" sx={{ width: 200, height: 200 }} src={`${baseUrl}/get_photo/${allData.picture}`} className="shadow-lg">KS</Avatar> 
                                     
                              </div>
                          }
                    <KeyValueGrid allData={allData} filterData={filterData} type={type} />

                      
 
                     {
                      loan_category?.loan_category === "thirdparty" && <>
                      
                      
                      { 
  
                      type ===  "GUARANTOR'S DETAILS" &&
                     <div>
                      <p className="p-4 bg-slate-50">I, <span className="font-extrabold pl-2 pr-2"> {loan_category?.loan_category === "studentloan" ? allData.first_name : <>{usesomeDate.sponsorIdentification?.[0].first_name}</> }  </span> acknowledge that all information and documents provided by me are genuine and if it is found to be otherwise, my application should be rendered void.</p> 
                     
                      </div>
               
  
  
                      }
                      
                      
                      
                      </>
                     }


                   {loan_category?.loan_category === "studentloan" && <>
                   
                   
                   { 

                    type ===  "PERSONAL REFERENCE" &&
                   <div>
                    <p className="p-4 bg-slate-50">I, <span className="font-extrabold pl-2 pr-2"> {usesomeDate.bio_data[0]?.fname} {usesomeDate.bio_data[0]?.md_name} {usesomeDate.bio_data[0]?.lname}   </span> acknowledge that all information and documents provided by me are genuine and if it is found to be otherwise, my application should be rendered void.</p> 
                   
                    </div>
             


                    }
                   
                   
                   
                   </>}


                    
                  </CardContent>

                    {
                      loan_category?.loan_category === "thirdparty" && 

                      <>
                      
                        {
                    (  type ===  "GUARANTOR'S DETAILS")&&
                  <div className="w-full flex-col flex justify-end bg-slate-100 border-t p-2">
                     <Button
                      variant="contained"
                      startIcon={<CloudDownloadIcon />}
                      size="small"
                      className="m-4"
                      onClick={acknowledge}
                      disabled={ acknowledged.length > 0 && acknowledged[0].mssg === "acknowledged"}   
                      >
                      acknowledge
                    </Button>
                    {(acknowledged.length > 0 && acknowledged[0].mssg === "acknowledged") &&   <p className="text-center">You can move to the <Button variant="contained" onClick={()=>Navigate("/application/apply_loan")}>Next</Button> step of your application</p> }
                  
                  </div>
                   }
                      
                      </>
                    }


                    {
                      loan_category?.loan_category === "studentloan" && 

                      <>
                      
                        {
                    ( type ===  "PERSONAL REFERENCE" )&&
                  <div className="w-full flex-col flex justify-end bg-slate-100 border-t p-2">
                     <Button
                      variant="contained"
                      startIcon={<CloudDownloadIcon />}
                      size="small"
                      className="m-4"
                      onClick={acknowledge}
                      disabled={ acknowledged.length > 0 && acknowledged[0].mssg === "acknowledged"}   
                      >
                      acknowledge
                    </Button>
                    {(acknowledged.length > 0 && acknowledged[0].mssg === "acknowledged") &&   <p className="text-center">You can move to the <Button variant="contained" onClick={()=>Navigate("/application/apply_loan")}>Next</Button> step of your application</p> }
                  
                  </div>
                   }
                      
                      </>
                    }
                  

    </Card> 

  );
}

function KeyValueGrid({ allData,filterData,type }) {
  
  if (!allData) return null;
   let  selected

   if(allData){
       selected = _.pick(allData,filterData );
       
   }
   
  const entries = Object.entries(selected)
  return (
    <Grid container spacing={2} className="mt-2">
      {entries.map(([k, v]) => (

        <Grid item xs={12} sm={6} md={4} key={k}>

          <div className="p-3 bg-white/60 rounded-lg shadow-sm border border-gray-100">
            <div className="text-xs text-gray-500">{niceLabel(k)}</div>
            <div className="mt-1 font-medium break-words">{v === null || v === undefined || v === "" ? <span className="text-gray-400">—</span> : String(v)}</div>
          </div>
           
        </Grid> 
      ))}
    </Grid>
  );


}



export default function LoanApplicationProfilePreview({typeForUser, applicanttoken,from ,file_token}) {

  
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [allData,setallData] = useState([])
  const {UserTokens,accesstoken} = useContext(ContextData)
 
  const [AdminCre,setAdminCre] = useState([])
const  user_roles = [
           "Administrator",
          "Manage",
          "Selector",
          "Validator",
          "Verifier",
          "Bank reviewer",
          "account-helper",
          "Manage Loan",
          "Manage Scholarship",
          "Manage Loan General"
           ]



  useEffect(()=>{

             async function Get () {
            
                 
                          GetAdminCredentials(UserTokens,accesstoken).then(res =>{
                           
                             setAdminCre(res)
                                       
                                })
                              

                 const BioPerson = await Getrequest(`/auth/get_bio/${applicanttoken}`,accesstoken)

                  

                   if(BioPerson)  setallData(BioPerson)


                 const LoanData = await Getrequest(`/auth/get_loan_data/${applicanttoken}`,accesstoken)
                 
                 setallData(prev=>({
                       ...prev,
                       ...LoanData
                 }))

                 setLoading(false);

               //  console.log(allData)
                    
             }Get()
  },[])




  function handlePrint() {
    window.print();
  }

  const showList = ["disbursedone","readydisburs","Disbursement_Approved","disbursmetn_unit"]

/*   function handleDownloadJSON() {
    const filename = `loan_profile_${applicantId || "sample"}.json`;
    const blob = new Blob([JSON.stringify(data || MOCK_DATA, null, 2)], { type: "application/json" });
    const href = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = href;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(href);
  }
 */



  return (
    <div className="p-6 min-h-screen bg-gradient-to-b from-gray-50 to-white main-header-preview-page-con">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-6 header-preview-page-con">

          <div className="flex items-center gap-4">
           
             <div className="w-[15%] ">

            <Avatar sx={{ width: 110, height: 110 }} src="/assets/newksslb.jpg" className="shadow-lg">KS</Avatar>
             </div>
             </div>

            <div className="w-[80%]  p-2 flex justify-center items-center font-mono">
              <div className="">
              <Typography variant="h6" component="div" className="kd-text-stkr">
                <span className="font-extrabold"> KADUNA STATE SCHOLARSHIP AND LOANS BOARD</span>
               
              </Typography>
              {
                allData?.loanrequest?.[0]?.loan_category === "thirdparty" ? 
              <Typography variant="subtitle1" className="uppercase text-sm tracking-wide kd-text-stkr">
                STUDENT TERTIARY EDUCATION LOAN (THIRD PARTY)
              </Typography>  
              :
              <Typography variant="subtitle1" className="uppercase text-sm tracking-wide">
                STUDENT TERTIARY EDUCATION LOAN (STUDENT LOAN)
              </Typography>
              }
               <Typography variant="subtitle1" className="uppercase text-sm tracking-wide kd-text-stkr-preview-text">
               Loan Application Profile Preview
              </Typography>

              </div>
            </div>

          <div className="flex items-center gap-2 w-[5%]  ">
          {/*   <Button
              variant="outlined"
              startIcon={<CloudDownloadIcon />}
              onClick={handleDownloadJSON}
              size="small"
              className="mr-2"
            >
              Export JSON
            </Button> */}

            {
              from !== "viewdoc" &&
              <IconButton color="" sx={{color:"blue",fontSize:"2em"}} onClick={handlePrint} title="Print">
              <PrintIcon />
              
            </IconButton>
            }
          
          
          </div>
        </div>

        <div className="space-y-6">
          {/* Applicant summary card (static headline info) */}
          <Card className="shadow-xl rounded-2xl overflow-hidden">
              <div className="w-full flex justify-between bg-slate-600">
                 <Typography variant="h5" className="font-extrabold p-1 text-white">
                    Applicant Bio
                  </Typography>
             
                 <div className="text-right flex justify-center items-center">
                  
                  <div className="text-sm text-white pr-1">Status</div>
                  <div className="mt-1 inline-block px-3 py-1 rounded-full bg-emerald-100 text-emerald-700 font-semibold">Draft</div>
                </div>

              </div>
         
          </Card>

          {/* Sections rendered from the schemas - each is a card with a small header */}
          {loading ? (
            <div className="text-center py-12">Loading preview...</div>
          ) : (

              <>
              
                 {
                  (from === "bankreviewer" || from === "disbursement") ?
                   <div className="space-y-4">

                {
                  allData.length === 0 ? 
                  <div className="text-center py-12">No Data Available</div>:
                  <>
                       { allData?.loanrequest?.[0]?.loan_category  === "thirdparty" && 
                       
                         <> 

                       <div className="text-center p-4">
                       <h1 className="text-2xl font-semibold text-green-800 mb-2">
                           LOAN REQUEST 
                        </h1>


                          <div className="flex">
                        


                             {
                              showList.includes(typeForUser) ? 

                              <></>
                              :
                               <CalculatorDialogue typeForUser={typeForUser} userTYpe={from} from="thirdparty" email={allData?.sign_up?.[0].email} Sponsor={allData?.sponsorIdentification?.[0]} Student={allData?.bio_data?.[0]} user_tokens={allData?.loanrequest[0]?.token} loanAmount={allData?.loanrequest[0]?.loan_amount} tenor={allData?.loanrequest[0]?.tenor} />

                                 }
                         


                               {
                                 AdminCre.length > 0 &&  (AdminCre[0].acct_typ === user_roles[9] || AdminCre[0].acct_typ === user_roles[5] ) &&
                                  <>
                                   {(from === "bankreviewer" || from === "disbursement") ? <>
                                   
                                     {
                                      showList.includes(typeForUser) && 

                                       <CalculatorDialogue typeForUser={typeForUser} changeT="Treat Request Letter" userTYpe={"request-letter"} loanrequest={allData?.loanrequest?.[0]} guarantor={allData?.guarantor_details?.[0]} from="thirdparty" email={allData?.sign_up?.[0].email} Sponsor={allData?.sponsorIdentification?.[0]} Student={allData?.bio_data?.[0]} user_tokens={allData?.loanrequest[0]?.token} loanAmount={allData?.loanrequest[0]?.loan_amount} tenor={allData?.loanrequest[0]?.tenor} />

                                     }
                                   
                                   
                                    </> :
                                   
                                 <CalculatorDialogue userTYpe={"request-letter"} loanrequest={allData?.loanrequest?.[0]} guarantor={allData?.guarantor_details?.[0]} from="thirdparty" email={allData?.sign_up?.[0].email} Sponsor={allData?.sponsorIdentification?.[0]} Student={allData?.bio_data?.[0]} user_tokens={allData?.loanrequest[0]?.token} loanAmount={allData?.loanrequest[0]?.loan_amount} tenor={allData?.loanrequest[0]?.tenor}  />
                                   }
                                  
                                  </>

                               }

                          

                          
                         </div>
                        </div>

                        <MainCard id="loanrequestComplete" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.loanrequest?.[0]} filterData={FilterList?.loanrequest} type="LOAN REQUEST" />


                         
                      {/*   <div className="text-center p-4">
                        <h2 className="text-lg font-semibold text-green-800 mb-2">
                        Sponsor Information and Related Details
                        </h2>
                        <p className="text-gray-700 text-sm leading-relaxed">
                        Below are the details of your sponsor as provided during your loan application process. 
                        Please review the information carefully to ensure accuracy. 
                        These details will be used for verification and correspondence related to your loan request.
                        </p>
                        </div> */}
                         
                         
                         {/*    <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens}  allData={allData?.sponsorIdentification?.[0]} filterData={FilterList?.sponsorIdentification} type="SPONSOR IDENTIFICATION" />
                            <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.spouse_details?.[0]} filterData={FilterList?.spouse_details} type="SPOUSE DETAILS" />
                            <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.residentialAddress?.[0]} filterData={FilterList?.residentialAddress} type="RESIDENTIAL ADDRESS" />
                             <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.employment_details?.[0]} filterData={FilterList?.employment_details} type="EMPLOYMENT DETAILS" />
                             <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} usesomeDate={allData} allData={allData?.salary_bank_details?.[0]} filterData={FilterList?.salary_bank_details} type="SALARY BANK DETAILS" />
                              <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.personal_references?.[0]} filterData={FilterList?.personal_references} type="PERSONAL REFERENCE" /> */}
                           

                          {/*  <div className="text-center p-4">
                        <h2 className="text-lg font-semibold text-green-800 mb-2">
                        Guarantors’ Information and Related Details
                        </h2>
                        <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line text-justify">

                        (Eligibility for Guarantorship: A Guarantor shall be: A civil servant in the Federal, State, or Local Government not below the rank of an equivalent of an Assistant Director, or not below Grade Level 15; 
                        A Chief  Magistrate or a Judge or Justice of a superior court of record;
                        An academic staff of a tertiary institution not below the rank of an equivalent of
                        Lecturer II, or a non-academic staff not below the rank of Assistant Registrar;
                        A traditional ruler not below the position of a District Head;
                        A military, police or paramilitary officer not below the rank or
                        an equivalent of lieutenant; and
                        Any person in the Private Sector who the Partner Bank is satisfied with their income and earnings).

                        </p>
                        </div> */}


                         {/*    <MainCard id=""  loan_category={allData?.loanrequest?.[0]} applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens}  usesomeDate={allData} allData={allData?.guarantor_details?.[0]} filterData={FilterList?.guarantor_details} type="GUARANTOR'S DETAILS" />
                   */}
                         
                         
                 
                         
                         </>
                       
                       }
                                          
    

                         { allData?.loanrequest?.[0]?.loan_category  === "studentloan" && 
                       
                         <> 

                          <div className="text-center p-4">
                          <h1 className="text-2xl font-semibold text-green-800 mb-2">
                           LOAN REQUEST {typeForUser}
                          </h1>
                          <div className="flex">

                             {
                              showList.includes(typeForUser) ? 

                              <></>
                              :
                              <CalculatorDialogue userTYpe={from} loanrequest={allData?.loanrequest?.[0]} guarantor={allData?.guarantor_details?.[0]} from="studentloan" email={allData?.sign_up?.[0].email} Sponsor={allData?.sponsorIdentification?.[0]} Student={allData?.bio_data?.[0]} user_tokens={allData?.loanrequest[0]?.token} loanAmount={allData?.loanrequest[0]?.loan_amount} tenor={allData?.loanrequest[0]?.tenor} />

                             }
                               {
                                 AdminCre.length > 0 &&  (AdminCre[0].acct_typ === user_roles[9] || AdminCre[0].acct_typ === user_roles[5]) &&
                                  <>
                                   {(from === "bankreviewer" || from === "disbursement") ? <>
                                   
                                     {
                                      showList.includes(typeForUser) && 

                                       <CalculatorDialogue typeForUser={typeForUser} changeT="Treat Request Letter"  userTYpe={"request-letter"} loanrequest={allData?.loanrequest?.[0]} guarantor={allData?.guarantor_details?.[0]} from="studentloan" email={allData?.sign_up?.[0].email} Sponsor={allData?.sponsorIdentification?.[0]} Student={allData?.bio_data?.[0]} user_tokens={allData?.loanrequest[0]?.token} loanAmount={allData?.loanrequest[0]?.loan_amount} tenor={allData?.loanrequest[0]?.tenor} />

                                     }
                                   
                                   
                                    </> :
                                   
                                  <CalculatorDialogue typeForUser={typeForUser} userTYpe={"request-letter"} loanrequest={allData?.loanrequest?.[0]} guarantor={allData?.guarantor_details?.[0]} from="studentloan" email={allData?.sign_up?.[0].email} Sponsor={allData?.sponsorIdentification?.[0]} Student={allData?.bio_data?.[0]} user_tokens={allData?.loanrequest[0]?.token} loanAmount={allData?.loanrequest[0]?.loan_amount} tenor={allData?.loanrequest[0]?.tenor}  />
                                   }
                                  
                                  </>

                               }

                          </div>
                          </div>
                           
                             

                          <MainCard id="loanrequestComplete" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.loanrequest?.[0]} filterData={FilterList?.loanrequest} type="LOAN REQUEST" />

                         
                      {/*   <div className="text-center p-4">
                        <h2 className="text-lg font-semibold text-green-800 mb-2">
                        Guarantors’ Information and Related Details
                        </h2>
                        <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line text-justify">

                        (Eligibility for Guarantorship: A Guarantor shall be: A civil servant in the Federal, State, or Local Government not below the rank of an equivalent of an Assistant Director, or not below Grade Level 15; 
                        A Chief  Magistrate or a Judge or Justice of a superior court of record;
                        An academic staff of a tertiary institution not below the rank of an equivalent of
                        Lecturer II, or a non-academic staff not below the rank of Assistant Registrar;
                        A traditional ruler not below the position of a District Head;
                        A military, police or paramilitary officer not below the rank or
                        an equivalent of lieutenant; and
                        Any person in the Private Sector who the Partner Bank is satisfied with their income and earnings).

                        </p>
                        </div> */}

                         {/*  <MainCard id=""  loan_category={allData?.loanrequest?.[0]} applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens}  usesomeDate={allData} allData={allData?.guarantor_details?.[0]} filterData={FilterList?.guarantor_details} type="GUARANTOR'S DETAILS" /> */}
                        
                 
                  
                         
                         
                         
                         
                         
                         
                         
                         
                         
                         
                         
                         
                         </>
                       
                       }







                  </>
                }



              
            </div>
                  :

                  <div className="space-y-4">

                {
                  allData.length === 0 ? 
                  <div className="text-center py-12">No Data Available</div>:
                  <>



                  <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens}  allData={allData?.bio_data?.[0]} filterData={FilterList?.bio_data} type="bio_data" />
                  <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.demography_data?.[0]} filterData={FilterList?.demography_data} type="demography_data" />
                  <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.edu_data?.[0]} filterData={FilterList?.edu_data} type="ACADEMIC DETAILS" />
                  <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.social_media_data?.[0]} filterData={FilterList?.social_media_data} type="Social Media Details" />
                  <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.bank_details_data?.[0]} filterData={FilterList?.bank_details_data} type="BANK DETAILS" />
                       
                 





                       { allData?.loanrequest?.[0]?.loan_category  === "thirdparty" && 
                       
                         <> 

                             <div className="text-center p-4">
                       <h1 className="text-2xl font-semibold text-green-800 mb-2">
                           LOAN REQUEST
                        </h1>
                      
                        </div>
                          <MainCard id="loanrequestComplete" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.loanrequest?.[0]} filterData={FilterList?.loanrequest} type="LOAN REQUEST" />


                         
                        <div className="text-center p-4">
                        <h2 className="text-lg font-semibold text-green-800 mb-2">
                        Sponsor Information and Related Details
                        </h2>
                        <p className="text-gray-700 text-sm leading-relaxed">
                        Below are the details of your sponsor as provided during your loan application process. 
                        Please review the information carefully to ensure accuracy. 
                        These details will be used for verification and correspondence related to your loan request.
                        </p>
                        </div>
                         
                         
                            <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens}  allData={allData?.sponsorIdentification?.[0]} filterData={FilterList?.sponsorIdentification} type="SPONSOR IDENTIFICATION" />
                            <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.spouse_details?.[0]} filterData={FilterList?.spouse_details} type="SPOUSE DETAILS" />
                            <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.residentialAddress?.[0]} filterData={FilterList?.residentialAddress} type="RESIDENTIAL ADDRESS" />
                             <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.employment_details?.[0]} filterData={FilterList?.employment_details} type="EMPLOYMENT DETAILS" />
                             <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} usesomeDate={allData} allData={allData?.salary_bank_details?.[0]} filterData={FilterList?.salary_bank_details} type="SALARY BANK DETAILS" />
                              <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.personal_references?.[0]} filterData={FilterList?.personal_references} type="PERSONAL REFERENCE" />
                           

                           <div className="text-center p-4">
                        <h2 className="text-lg font-semibold text-green-800 mb-2">
                        Guarantors’ Information and Related Details
                        </h2>
                        
                        </div>


                            <MainCard id=""  loan_category={allData?.loanrequest?.[0]} applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens}  usesomeDate={allData} allData={allData?.guarantor_details?.[0]} filterData={FilterList?.guarantor_details} type="GUARANTOR'S DETAILS" />
                  
                         
                         
                         
                         
                         
                         
                         
                         
                         
                         
                         
                         
                         </>
                       
                       }
                                          
    

                         { allData?.loanrequest?.[0]?.loan_category  === "studentloan" && 
                       
                         <> 

                          <div className="text-center p-4">
                       <h1 className="text-2xl font-semibold text-green-800 mb-2">
                           LOAN REQUEST
                        </h1>
                      
                        </div>
                           
                             

                          <MainCard id="loanrequestComplete" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.loanrequest?.[0]} filterData={FilterList?.loanrequest} type="LOAN REQUEST" />

                         
                        <div className="text-center p-4">
                        <h2 className="text-lg font-semibold text-green-800 mb-2">
                        Guarantors’ Information and Related Details
                        </h2>
                        <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line text-justify">

                        (Eligibility for Guarantorship: A Guarantor shall be: A civil servant in the Federal, State, or Local Government not below the rank of an equivalent of an Assistant Director, or not below Grade Level 15; 
                        A Chief  Magistrate or a Judge or Justice of a superior court of record;
                        An academic staff of a tertiary institution not below the rank of an equivalent of
                        Lecturer II, or a non-academic staff not below the rank of Assistant Registrar;
                        A traditional ruler not below the position of a District Head;
                        A military, police or paramilitary officer not below the rank or
                        an equivalent of lieutenant; and
                        Any person in the Private Sector who the Partner Bank is satisfied with their income and earnings).

                        </p>
                        </div>

                          <MainCard id=""  loan_category={allData?.loanrequest?.[0]} applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens}  usesomeDate={allData} allData={allData?.guarantor_details?.[0]} filterData={FilterList?.guarantor_details} type="GUARANTOR'S DETAILS" />
                         <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.spouse_details?.[0]} filterData={FilterList?.spouse_details} type="SPOUSE DETAILS" />
                        <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.residentialAddress?.[0]} filterData={FilterList?.residentialAddress} type="RESIDENTIAL ADDRESS" />
                         <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.employment_details?.[0]} filterData={FilterList?.employment_details} type="EMPLOYMENT DETAILS" />
                          <MainCard id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} usesomeDate={allData} allData={allData?.salary_bank_details?.[0]} filterData={FilterList?.salary_bank_details} type="SALARY BANK DETAILS" />
                         <MainCard usesomeDate={allData} loan_category={allData?.loanrequest?.[0]} id="" applicanttoken={applicanttoken} file_token={file_token} from={from}  verifierToken={UserTokens} allData={allData?.personal_references?.[0]} filterData={FilterList?.personal_references} type="PERSONAL REFERENCE" />
                 
                  
                         
                         
                         
                         
                         
                         
                         
                         
                         
                         
                         
                         
                         </>
                       
                       }







                  </>
                }



              
            </div>
                 }
              </>
            
          )}

          <div className="text-right mmt-sticker-text">
            <Typography variant="body2" className="text-gray-500">Powered by MastermindTech</Typography>
          </div>
        </div>
      </div>

      {/* Print styles to make the output more compact on paper */}
      <style jsx>{`
        @media print {
          body * {
            visibility: hidden;
          }
          .min-h-screen, .min-h-screen * {
            visibility: visible;
          }
          .min-h-screen {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
          }
          .MuiButton-root, .MuiIconButton-root {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
}
